<template>
  <AdminLayout><ConfirmedOrdersTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import ConfirmedOrdersTable from './ConfirmedOrdersTable.vue';

export default {
  name: 'ConfirmedOrders',
  components: { AdminLayout, ConfirmedOrdersTable },
};
</script>
